<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  props: ['data'],
  methods: {
    getPlaceholderLabels() {
      const placeholderLabels = {
        1: this.$t('statistics.status_1'),
        2: this.$t('statistics.status_2'),
        3: this.$t('statistics.status_3'),
        4: this.$t('statistics.status_4'),
        5: this.$t('statistics.status_5'),
        6: "Bez odpovede",
        7: "Hotovo",
        8: this.$t('statistics.status_8')
      };

      return Object.keys(this.data).map(id => placeholderLabels[id] || `Label for ID ${id}`);
    },
    getColors() {
      const colors = {
        1: "#ECEAE5",
        2: "#8ED19A",
        3: "#F55C50",
        4: "#62CBEA",
        5: "#FFB970",
        6: "#B07FCE",
        7: "#FFCA4F",
        8: "#ff8c9a"
      };

      return Object.keys(this.data).map(id => colors[id] || '#000000');
    },
    getCounts() {
      return Object.keys(this.data).map(id => {
        const entry = this.data[id];
        return typeof entry === 'object' && entry !== null ? entry.count : entry;
      });
    },
    getPrices() {
      return Object.keys(this.data).map(id => {
        const entry = this.data[id];
        return typeof entry === 'object' && entry !== null ? entry.price : null;
      });
    }
  },
  mounted() {
    if (this.data && typeof this.data === 'object') {
      const currencyCode = this.$currency.code;
      const labels = this.getPlaceholderLabels();
      const counts = this.getCounts();
      const prices = this.getPrices();
      const backgroundColors = this.getColors();
      
      this.renderChart(
        {
          labels: labels,
          datasets: [
            {
              data: counts,
              backgroundColor: backgroundColors,
              // custom parallel array for tooltip price lookup
              prices: prices
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const dataset = data.datasets[tooltipItem.datasetIndex] || {};
                const index = tooltipItem.index;
                const label = (data.labels && data.labels[index]) ? data.labels[index] : '';
                const value = (dataset.data && dataset.data[index] != null) ? dataset.data[index] : 0;
                const price = (dataset.prices && dataset.prices[index] != null) ? dataset.prices[index] : null;
                const parts = [];
                if (label) parts.push(label + ': ' + value);
                else parts.push(String(value));
                if (price != null) {
                  try {
                    const formatted = new Intl.NumberFormat('sk-SK', { style: 'currency', currency: currencyCode }).format(price);
                    parts.push('(' + formatted + ')');
                  } catch (e) {
                    parts.push('(' + price + ')');
                  }
                }
                return parts.join(' ');
              }
            }
          }
        }
      );
    }
  }
};
</script>
